import React, { useCallback } from 'react';

import Dropdown, { DropdownMenu, MenuItem } from '@adsk/alloy-react-dropdown';
import FormField from '@adsk/alloy-react-form-field';
import Portal from '@adsk/alloy-react-portal';

import useFormStatusOptions from './hooks/useFormStatusOptions';
import { useTranslation } from './i18n';
import StatusColorLabel from './StatusColorLabel';

const dropdownStyle = { width: '100%' };

const renderMenu = (menuProps, virtualProps) => (
  <Portal container={document.body}>
    {DropdownMenu.render(menuProps, virtualProps)}
  </Portal>
);

const renderMenuItem = ({ item, ...props }) => (
  <MenuItem
    {...props}
    text={<StatusColorLabel color={item.color} label={item.label} />}
  />
);

const StatusFilter = ({ filters, onChangeFilter }) => {
  const { t } = useTranslation();
  const statusOptions = useFormStatusOptions();
  const selectedStatuses = statusOptions.filter((status) =>
    filters.statuses?.includes(status.value),
  );
  const handleSelectedItemsChange = useCallback(
    ({ selectedItems = [] }) => {
      onChangeFilter(
        'statuses',
        selectedItems.map((status) => status.value),
      );
    },
    [onChangeFilter],
  );

  return (
    <FormField label={t('STATUS')} labelVariant={FormField.LABEL_VARIANTS.TOP}>
      <Dropdown
        style={dropdownStyle}
        isMultiple
        items={statusOptions}
        selectedItems={selectedStatuses}
        renderMenu={renderMenu}
        renderMenuItem={renderMenuItem}
        onSelectedItemsChange={handleSelectedItemsChange}
      />
    </FormField>
  );
};

export default StatusFilter;
